import { minLength, maxLength, stringPattern, urlPattern, stringPatternError, tagMinLength, tagMaxLength } from '../../utils/form-validations';

export const addComponentDefaultFields = {
  docker_image_url: '',
  component_name: '',
  service_id: '',
  backend_schema: {},
  ui_schema: {},
};

export const addComponentUISchema = [
  { id: 1, label: 'Docker image URL', name: 'docker_image_url', type: 'input', required: true },
  { id: 2, label: 'Display Name', name: 'component_name', type: 'input', required: true },
  { id: 3, label: 'Service', name: 'service_id', type: 'select', required: true },
  { id: 4, label: 'Backend Schema', name: 'backend_schema', type: 'textarea', required: false },
  { id: 5, label: 'UI Schema', name: 'ui_schema', type: 'textarea', required: false },
];

export const addComponentSchema = {
  type: 'object',
  properties: {
    docker_image_url: { type: 'string', minLength, maxLength },
    component_name: {
      type: 'string',
      minLength,
      maxLength,
    },
    service_id: { type: 'number', minLength: 1 },
    backend_schema: {},
    ui_schema: {},
  },
  required: ['docker_image_url', 'component_name', 'service_id'],
  additionalProperties: true,
};

export const addComponentTagsSchema = {
  type: 'object',
  properties: {
    id: { type: 'number' },
    display_name: { type: 'string', minLength: tagMinLength, maxLength: tagMaxLength, pattern: stringPattern },
    request: { type: 'string', minLength: tagMinLength, maxLength: tagMaxLength, pattern: stringPattern },
    response: { type: 'string', minLength: tagMinLength, maxLength: tagMaxLength,pattern: stringPattern },
  },
  required: ['display_name', 'request','response'],
};
